import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import useSeo from "../hooks/useSeo";
import useUserMaritalStatus from "../hooks/useUserMaritalStatus";
import AiModuleTabs from "../components/AiModuleTabs";

const TOPICS = [
  {
    title: "婚前沟通",
    desc: "结婚期待、价值观、相处底线怎么谈清楚",
    q: "我们准备结婚，婚前需要沟通哪些关键问题？",
  },
  {
    title: "家庭关系",
    desc: "见家长、双方父母边界、节假日安排",
    q: "和双方父母相处总有压力，怎么设边界？",
  },
  {
    title: "冲突解决",
    desc: "吵架、冷战、反复争执如何降温",
    q: "我们一吵架就冷战，怎么打破这个循环？",
  },
  {
    title: "婚姻规划",
    desc: "财务、居住、育儿与责任分工",
    q: "想做一份简单的婚姻规划清单，从哪里开始？",
  },
  {
    title: "结婚登记",
    desc: "结婚证、材料与流程常识（一般性参考）",
    q: "办理结婚登记一般需要准备什么材料？",
  },
];

export default function AiMarriagePage() {
  const navigate = useNavigate();
  const userId = Number(localStorage.getItem("user_id"));
  const { isMarried } = useUserMaritalStatus();

  useSeo({
    title: "AI婚姻顾问 | 婚前沟通与关系经营",
    metaDescription: "面向恋爱中、准备结婚与已婚用户的婚姻沟通、家庭关系与冲突解决顾问。",
    path: "/ai/marriage",
  });

  useEffect(() => {
    if (!userId) {
      navigate(`/login?redirect=${encodeURIComponent("/ai/marriage")}`, {
        replace: true,
      });
    }
  }, [userId, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50 flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-8 space-y-8">
        <AiModuleTabs groupKey="advisor" />
        <div className="text-center space-y-3">
          <h1 className="text-3xl font-extrabold text-gray-900">AI 婚姻顾问</h1>
          <p className="text-sm text-gray-500 max-w-2xl mx-auto">
            {isMarried
              ? "专注夫妻沟通、家庭边界、冲突修复与结婚登记常识。"
              : "适合恋爱中、准备结婚的你：婚前沟通、家庭关系、冲突解决与婚姻规划。"}
          </p>
          <Link
            to="/ai/consultant?mode=marriage"
            className="inline-block px-6 py-3 rounded-full bg-rose-500 text-white text-sm font-medium hover:bg-rose-600"
          >
            开始咨询
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {TOPICS.map((t) => (
            <Link
              key={t.title}
              to={`/ai/consultant?mode=marriage&q=${encodeURIComponent(t.q)}`}
              className="bg-white rounded-2xl border border-rose-100 p-5 shadow-sm hover:border-rose-300 transition text-left"
            >
              <h2 className="font-bold text-gray-900">{t.title}</h2>
              <p className="text-sm text-gray-500 mt-2">{t.desc}</p>
              <p className="text-xs text-rose-600 mt-3">点此开始聊 →</p>
            </Link>
          ))}
        </div>

        <div className="bg-white/80 rounded-2xl border border-gray-100 p-5 text-sm text-gray-600">
          <p>
            涉及法律效力（离婚、财产等）请以当地民政局或律师意见为准。需要真人陪伴时，可
            <Link to="/consultants" className="text-rose-600 underline mx-1">
              预约咨询师
            </Link>
            。
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
